import { render, staticRenderFns } from "./BlipIntegracoes.vue?vue&type=template&id=a3299984&scoped=true&"
import script from "./BlipIntegracoes.vue?vue&type=script&lang=js&"
export * from "./BlipIntegracoes.vue?vue&type=script&lang=js&"
import style0 from "./BlipIntegracoes.vue?vue&type=style&index=0&id=a3299984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3299984",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
installComponents(component, {VColorPicker})
